<template>
  <v-card color="grey darken-3" class="max-auto mb-6" tile>
    <v-card-title>Publishing</v-card-title>

    <v-list two-line subheader color="secondary pb-0" style="border-radius:0;">
      <v-list-item v-if="findStatus">
        <v-list-item-avatar>
          <v-icon :color="findStatus.color">power_settings_new</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>Statut</v-list-item-subtitle>
          <v-spacer />
          <v-list-item-title>{{ findStatus.label }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-content v-if="publishedAt" class="d-flex justify-end mr-4">
          <v-switch v-model="newOnline" class="switcher" :label="newOnline ? 'En ligne' : 'Hors ligne'" :readonly="!$store.getters.permissionToWrite" />
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item v-if="publishedAt">
        <v-list-item-avatar>
          <v-icon>publish</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>Version publiée</v-list-item-subtitle>
          <v-spacer />
          <v-list-item-title>{{ formatDateTime(publishedAt) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider v-if="publishedAt" />

      <v-card-text>
        <v-list-item class="px-0">
          <v-list-item-avatar>
            <v-icon>timer</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <DTPicker
              v-model="newStartPublicationDate"
              :field="{...optionsPicker, label: 'Date de début de publication', readonly: !$store.getters.permissionToWrite }"
              :hide-icon="true"
            />
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="px-0">
          <v-list-item-avatar>
            <v-icon>timer_off</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <DTPicker
              v-model="newEndPublicationDate"
              :field="{...optionsPicker, label: 'Date de fin de publication', readonly: !$store.getters.permissionToWrite }"
              :hide-icon="true"
            />
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-list>
  </v-card>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

import { formatDateTime } from '../../utils/index';

import DTPicker from '@/components/editor/DTPicker.vue';

// eslint-disable-next-line no-undef
const props = defineProps({
  status: { type: String, default: '' },
  states: { type: Array, default: () => [] },
  publishedAt: { type: String, default: '' },
  startPublicationDate: { type: String, default: '' },
  endPublicationDate: { type: String, default: '' },
  online: { type: Boolean, default: false }
});

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:startPublicationDate', 'update:endPublicationDate', 'update:online']);

const newStartPublicationDate = ref(props.startPublicationDate);

const newEndPublicationDate = ref(props.endPublicationDate);

const newOnline = ref(props.online);

const optionsPicker = {
  viewType: 'Date Picker',
  menu: false
};

const findStatus = computed(() => props.states.filter(state => state.id === props.status)[0]);

watch(newStartPublicationDate, async newValue => {
  // Updates prop via event
  emit('update:startPublicationDate', newValue);
});

watch(newEndPublicationDate, async newValue => {
  emit('update:endPublicationDate', newValue);
});

watch(newOnline, async newValue => {
  emit('update:online', newValue);
});

</script>
